import { render, staticRenderFns } from "./QuickscanStep3.vue?vue&type=template&id=a09c0270"
import script from "./QuickscanStep3.vue?vue&type=script&lang=js"
export * from "./QuickscanStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports